export const SET_USAGE_HISTORY = 'SET_USAGE_HISTORY'
export const RESET_USAGE_HISTORY = 'RESET_USAGE_HISTORY'